import React from "react";
import PrintIcon from "@mui/icons-material/Print";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Divider,
} from "@mui/material";
import moment from "moment";

const RowItem = ({
  label,
  value,
  isBold = false,
  isRed = false,
  isGrey = false,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 0.5,
      px: 2,
      borderBottom: "0.5px solid #ccc",
    }}
  >
    <Typography
      variant={isBold ? "subtitle1" : "body1"}
      sx={{
        fontWeight: isBold ? "bold" : "normal",
        color: isRed
          ? "error.main"
          : isGrey
            ? "text.secondary"
            : "text.primary",
        flex: 1,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant={isBold ? "subtitle1" : "body1"}
      sx={{
        fontWeight: isBold ? "bold" : "normal",
        color: isRed
          ? "error.main"
          : isGrey
            ? "text.secondary"
            : "text.primary",
        textAlign: "right",
        flex: 1,
      }}
    >
      {value}
    </Typography>
  </Box>
);

const formatRupiah = (amount) => {
  if (amount === null || amount === undefined) return "Rp 0";
  const isNegative = amount < 0;
  const formatted = Math.abs(amount).toLocaleString("id-ID", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${isNegative ? "(-) " : ""}Rp ${formatted}`;
};

const DetailSetoranHarianModal = ({
  open,
  onClose,
  dataDetail,
  dataPengeluaran,
  onSaveWarkat,
}) => {
  if (!open) return null;
  console.log("Data dataDetail", dataDetail);

  const hasData = !!dataPengeluaran;

  const hitungPecahan = (hasData, total, masuk, keluar, nominal) => {
    const totalVal = (total ?? 0) / nominal;
    const masukVal = (masuk ?? 0) / nominal;
    const keluarVal = (keluar ?? 0) / nominal;
    const hasil = totalVal + masukVal - keluarVal;
    return !hasData
      ? totalVal
      : `${hasil} (${totalVal} + ${masukVal} - ${keluarVal}) = ${formatRupiah(
          hasil * nominal,
        )}`;
  };
  const payloadDataWarkat = {
    nama: "Setoran Tunai Harian Cabang",
    tanggal_kas: moment(dataDetail.tanggal_kas).format(),
    tanggal_setoran: moment(dataDetail.tanggal_setoran).format(),
    tipe: "pemasukan",
    status: "realisasi",
    catatan: "Setoran dari semua cabang",
    nominal: hasData
      ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Number(dataPengeluaran?.nominal_pendapatan || 0) +
        // -
        // Number(dataPengeluaran?.nominal_pengeluaran || 0) +
        Number(dataDetail?.total_stl_akumulasi || 0) +
        Number(dataDetail?.total_debit_credit_akumulasi || 0) +
        Number(dataDetail?.total_ewallet_akumulasi || 0) +
        // Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
        Number(dataPengeluaran?.transfer_pendapatan || 0)
      : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Number(dataDetail?.total_stl_akumulasi || 0) +
        Math.abs(
          Number(dataDetail?.total_selisih_murni_akumulasi_kondisi || 0),
        ) +
        Number(dataDetail?.total_debit_credit_akumulasi || 0) +
        Number(dataDetail?.total_ewallet_akumulasi || 0),
    // +  Number(dataDetail?.total_pengeluaran_akumulasi || 0),
  };

  const handleSaveWarkat = () => {
    const isConfirmed = window.confirm(
      `Apakah Anda yakin ingin ${
        dataDetail.has_save_warkat ? "memperbaharui" : "menyimpan"
      } data warkat dengan nominal ${formatRupiah(payloadDataWarkat.nominal)}?`
    );

    if (isConfirmed) {
      onSaveWarkat(payloadDataWarkat);
    }
  };

  const handlePrint = () => {
    const tanggalKas = dataDetail?.tanggal_kas
      ? moment(dataDetail.tanggal_kas).format("DD MMMM YYYY")
      : "-";
    const tanggalSetoran = dataDetail?.tanggal_setoran
      ? moment(dataDetail.tanggal_setoran).format("DD MMMM YYYY")
      : "-";

    const rupiahFmt = (amount) => {
      if (amount === null || amount === undefined) return "Rp 0";
      const isNeg = amount < 0;
      const fmt = Math.abs(amount).toLocaleString("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return `${isNeg ? "(-) " : ""}Rp ${fmt}`;
    };

    const calcPecahan = (total, masuk, keluar, nominal) => {
      const totalVal = (total ?? 0) / nominal;
      const masukVal = (masuk ?? 0) / nominal;
      const keluarVal = (keluar ?? 0) / nominal;
      const hasil = totalVal + masukVal - keluarVal;
      return !hasData
        ? `${totalVal} lbr = ${rupiahFmt(totalVal * nominal)}`
        : `${hasil} lbr (${totalVal}+${masukVal}-${keluarVal}) = ${rupiahFmt(hasil * nominal)}`;
    };

    const totalOmzet = hasData
      ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Number(dataPengeluaran?.nominal_pendapatan || 0) +
        Number(dataDetail?.total_stl_akumulasi || 0) +
        Number(dataDetail?.total_debit_credit_akumulasi || 0) +
        Number(dataDetail?.total_ewallet_akumulasi || 0) +
        Number(dataPengeluaran?.transfer_pendapatan || 0)
      : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Number(dataDetail?.total_stl_akumulasi || 0) +
        Math.abs(Number(dataDetail?.total_selisih_murni_akumulasi_kondisi || 0)) +
        Number(dataDetail?.total_debit_credit_akumulasi || 0) +
        Number(dataDetail?.total_ewallet_akumulasi || 0);

    const selisihOmzet = totalOmzet - Number(dataDetail?.total_omzet_data_akumulasi || 0);

    const pecahanList = [
      { label: "100rb", nominal: 100000, total: dataDetail?.total_lembar_seratus, masuk: dataPengeluaran?.seratus_pendapatan, keluar: dataPengeluaran?.seratus_pengeluaran },
      { label: "50rb", nominal: 50000, total: dataDetail?.total_lembar_limapuluh, masuk: dataPengeluaran?.limapuluh_pendapatan, keluar: dataPengeluaran?.limapuluh_pengeluaran },
      { label: "20rb", nominal: 20000, total: dataDetail?.total_lembar_duapuluh, masuk: dataPengeluaran?.duapuluh_pendapatan, keluar: dataPengeluaran?.duapuluh_pengeluaran },
      { label: "10rb", nominal: 10000, total: dataDetail?.total_lembar_sepuluh, masuk: dataPengeluaran?.sepuluh_pendapatan, keluar: dataPengeluaran?.sepuluh_pengeluaran },
      { label: "5rb", nominal: 5000, total: dataDetail?.total_lembar_limaribu, masuk: dataPengeluaran?.limaribu_pendapatan, keluar: dataPengeluaran?.limaribu_pengeluaran },
      { label: "2rb", nominal: 2000, total: dataDetail?.total_lembar_duaribu, masuk: dataPengeluaran?.duaribu_pendapatan, keluar: dataPengeluaran?.duaribu_pengeluaran },
      { label: "1rb", nominal: 1000, total: dataDetail?.total_lembar_seribu, masuk: dataPengeluaran?.seribu_pendapatan, keluar: dataPengeluaran?.seribu_pengeluaran },
    ];

    const pecahanRows = pecahanList
      .map(
        (p) =>
          `<tr><td>Pecahan ${p.label}</td><td>${calcPecahan(p.total, p.masuk, p.keluar, p.nominal)}</td></tr>`,
      )
      .join("");

    const coinVal = !hasData
      ? rupiahFmt(dataDetail?.total_coin ?? 0)
      : `(${rupiahFmt(dataDetail?.total_coin ?? 0)} + ${rupiahFmt(dataPengeluaran?.coin_pendapatan ?? 0)} - ${rupiahFmt(dataPengeluaran?.coin_pengeluaran ?? 0)}) = ${rupiahFmt((Number(dataDetail?.total_coin) ?? 0) + (Number(dataPengeluaran?.coin_pendapatan) ?? 0) - (Number(dataPengeluaran?.coin_pengeluaran) ?? 0))}`;

    const catatanRows = dataDetail?.catatan_akumulasi
      ? dataDetail.catatan_akumulasi
          .split(" ; ")
          .filter((c) => c.trim())
          .map((c, i) => `<p class="note"><b>Note ${i + 1}:</b> ${c.trim()}</p>`)
          .join("")
      : "";

    const pendapatanListHtml = hasData && dataPengeluaran?.list_pendapatan
      ? dataPengeluaran.list_pendapatan
          .split(";")
          .map((item, i) => `<p>${i + 1}. ${item.trim()}</p>`)
          .join("")
      : "<p>-</p>";

    const pengeluaranListHtml = hasData && dataPengeluaran?.list_pengeluaran
      ? dataPengeluaran.list_pengeluaran
          .split(";")
          .map((item, i) => `<p>${i + 1}. ${item.trim()}</p>`)
          .join("")
      : "<p>-</p>";

    const pendapatanSection = hasData
      ? `<div class="rincian-section">
          <h3 style="text-align:center;margin-bottom:12px">Rincian Pendapatan &amp; Pengeluaran</h3>
          <div class="two-col-bottom">
            <div class="box-pendapatan">
              <h4 style="color:#2e7d32">PENDAPATAN</h4>
              <p class="label-sm">Total Pendapatan</p>
              <p class="bold green">${rupiahFmt(dataPengeluaran?.nominal_pendapatan)}</p>
              <p class="label-sm">List Pendapatan</p>
              ${pendapatanListHtml}
            </div>
            <div class="box-pengeluaran">
              <h4 style="color:#c62828">PENGELUARAN</h4>
              <p class="label-sm">Total Pengeluaran</p>
              <p class="bold red">${rupiahFmt(dataPengeluaran?.nominal_pengeluaran)}</p>
              <p class="label-sm">List Pengeluaran</p>
              ${pengeluaranListHtml}
            </div>
          </div>
        </div>`
      : "";

    const totalUangCash = hasData
      ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) -
        Number(dataDetail?.total_transfer || 0) +
        Number(dataPengeluaran?.nominal_pendapatan || 0)
      : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Math.abs(Number(dataDetail?.total_selisih_murni_akumulasi_kondisi || 0));

    const subtotalOmzet = hasData
      ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Number(dataPengeluaran?.nominal_pendapatan || 0) +
        Number(dataPengeluaran?.transfer_pendapatan || 0)
      : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Math.abs(Number(dataDetail?.total_selisih_murni_akumulasi_kondisi || 0));

    const totalUangTransfer = hasData
      ? Number(dataPengeluaran?.transfer_pendapatan || 0) + Number(dataDetail?.total_transfer || 0)
      : Number(dataDetail?.total_transfer || 0);

    const selisihRow = hasData
      ? `<tr><td>Pendapatan (+)</td><td class="green">${rupiahFmt(dataPengeluaran?.nominal_pendapatan || 0)}</td></tr>`
      : `<tr><td>Selisih Minus</td><td>${rupiahFmt(dataDetail?.total_selisih_murni_akumulasi_kondisi)}</td></tr>`;

    const transferPendapatanRow = hasData
      ? `<tr><td>Pendapatan Transfer (+)</td><td class="green">${rupiahFmt(dataPengeluaran?.transfer_pendapatan || 0)}</td></tr>`
      : "";

    const htmlContent = `<!DOCTYPE html>
<html lang="id">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Detail Setoran Global - ${tanggalSetoran}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, sans-serif; font-size: 12px; color: #222; background: #fff; padding: 20px; }
    h1 { font-size: 18px; text-align: center; font-weight: bold; margin-bottom: 4px; }
    .subtitle { text-align: center; color: #555; font-size: 12px; margin-bottom: 2px; }
    .divider { border: none; border-top: 1px solid #bbb; margin: 10px 0; }
    .two-col { display: flex; gap: 16px; margin-top: 12px; }
    .col { flex: 1; }
    table { width: 100%; border-collapse: collapse; }
    tr { border-bottom: 0.5px solid #ddd; }
    td { padding: 4px 8px; vertical-align: middle; }
    td:last-child { text-align: right; }
    .bold td { font-weight: bold; }
    .col-title { font-weight: bold; font-size: 13px; padding: 6px 8px; background: #f5f5f5; }
    .note { font-size: 11px; color: #666; padding: 4px 8px; }
    .green { color: #2e7d32; }
    .red { color: #c62828; }
    .rincian-section { margin-top: 16px; border-top: 1px solid #bbb; padding-top: 12px; }
    .two-col-bottom { display: flex; gap: 16px; margin-top: 8px; }
    .box-pendapatan, .box-pengeluaran { flex: 1; border: 1px solid #eee; border-radius: 4px; padding: 10px; }
    .box-pendapatan h4 { margin-bottom: 6px; } 
    .box-pengeluaran h4 { margin-bottom: 6px; }
    .label-sm { font-size: 11px; color: #777; margin-top: 6px; }
    .bold { font-weight: bold; }
    @media print {
      body { padding: 10px; }
      @page { margin: 15mm; }
    }
  </style>
</head>
<body>
  <h1>DETAIL SETORAN GLOBAL</h1>
  <p class="subtitle">Prima Centre DC - Sukabumi</p>
  <p class="subtitle">Sinkron - ${tanggalKas} &nbsp;|&nbsp; Setoran - ${tanggalSetoran}</p>
  <hr class="divider" />

  <div class="two-col">
    <!-- Kolom Kiri -->
    <div class="col">
      <table>
        <tr><td class="col-title" colspan="2">Ringkasan Setoran</td></tr>
        <tr><td>Jumlah Cabang</td><td>${dataDetail?.jumlah_cabang?.toString() || "0"}</td></tr>
        <tr class="bold"><td>Uang Cash</td><td>${rupiahFmt(Number(dataDetail?.total_setoran_cash_akumulasi || 0) - Number(dataDetail?.total_transfer || 0))}</td></tr>
        ${selisihRow}
        <tr class="bold"><td>Total Uang Cash</td><td>${rupiahFmt(totalUangCash)}</td></tr>
        ${transferPendapatanRow}
        <tr class="bold"><td>Uang Transfer</td><td>${rupiahFmt(dataDetail?.total_transfer)}</td></tr>
        <tr class="bold"><td>Total Uang Transfer</td><td>${rupiahFmt(totalUangTransfer)}</td></tr>
        <tr class="bold"><td>Subtotal Omzet</td><td>${rupiahFmt(subtotalOmzet)}</td></tr>
        <tr><td>STL</td><td>${rupiahFmt(dataDetail?.total_stl_akumulasi)}</td></tr>
        <tr><td>EDC Machine</td><td>${rupiahFmt(dataDetail?.total_debit_credit_akumulasi)}</td></tr>
        <tr><td>Qris</td><td>${rupiahFmt(dataDetail?.total_ewallet_akumulasi)}</td></tr>
        <tr class="bold"><td>Total Omzet</td><td>${rupiahFmt(totalOmzet)}</td></tr>
        <tr><td>Pengeluaran</td><td>${rupiahFmt(dataDetail?.total_pengeluaran_akumulasi)}</td></tr>
        <tr class="bold"><td>Total Omzet Data Server</td><td>${rupiahFmt(Number(dataDetail?.total_omzet_data_akumulasi || 0))}</td></tr>
        <tr class="bold"><td>Total Selisih Omzet</td><td class="${selisihOmzet < 0 ? "red" : ""}">  ${rupiahFmt(selisihOmzet)}</td></tr>
      </table>
      ${catatanRows}
    </div>

    <!-- Kolom Kanan -->
    <div class="col">
      <table>
        <tr><td class="col-title" colspan="2">Rincian Pecahan</td></tr>
        ${pecahanRows}
        <tr><td>Pecahan Coin</td><td>${coinVal}</td></tr>
      </table>
    </div>
  </div>

  ${pendapatanSection}

  <script>
    window.onload = function() { window.print(); };
  </script>
</body>
</html>`;

    const tab = window.open("", "_blank");
    if (tab) {
      tab.document.open();
      tab.document.write(htmlContent);
      tab.document.close();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: { width: "95 vw", maxHeight: "95 vh" },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          DETAIL SETORAN GLOBAL
        </Typography>
        <Typography color="text.secondary">
          Prima Centre DC - Sukabumi
        </Typography>
        <Typography color="text.secondary">
          {`Sinkron - ${
            dataDetail?.tanggal_kas
              ? moment(dataDetail.tanggal_kas).format("DD MMMM YYYY")
              : "-"
          } || Setoran - ${
            dataDetail?.tanggal_setoran
              ? moment(dataDetail.tanggal_setoran).format("DD MMMM YYYY")
              : "-"
          }`}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ p: 0, overflowY: "auto", maxHeight: "95 vh" }}>
        {/* BAGIAN KIRI */}
        <Box sx={{ display: "flex", borderBottom: "0.5px solid #ccc" }}>
          <Box sx={{ flex: 1, borderRight: "1px solid #eee", px: 2, py: 1 }}>
            <RowItem
              label="Jumlah Cabang"
              value={dataDetail?.jumlah_cabang?.toString() || "0"}
            />
            <RowItem
              label="Uang Cash"
              value={formatRupiah(
                dataDetail?.total_setoran_cash_akumulasi -
                  dataDetail?.total_transfer,
              )}
              isBold
            />

            {hasData && (
              <>
                <Box
                  sx={{
                    paddingY: 0.5,
                    paddingX: 2,
                    borderBottom: "0.5px solid #ccc",
                    backgroundColor: "#e8f5e9",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "600",
                        color: "success.main",
                      }}
                    >
                      Pendapatan (+)
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "success.main", fontWeight: "500" }}
                    >
                      {formatRupiah(dataPengeluaran?.nominal_pendapatan || 0)}
                    </Typography>
                  </Box>
                </Box>

                {/* <Box
                  sx={{
                    paddingY: 0.5,
                    paddingX: 2,
                    borderBottom: "0.5px solid #ccc",
                    backgroundColor: "#ffebee",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "600",
                        color: "error.main",
                      }}
                    >
                      Pengeluaran (-)
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "error.main", fontWeight: "500" }}
                    >
                      {formatRupiah(dataPengeluaran?.nominal_pengeluaran || 0)}
                    </Typography>
                  </Box>
                </Box> */}
              </>
            )}

            {!hasData && (
              <RowItem
                label="Selisih Minus"
                value={formatRupiah(
                  dataDetail?.total_selisih_murni_akumulasi_kondisi,
                )}
              />
            )}
            <RowItem
              label="Total Uang Cash"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) -
                      Number(dataDetail?.total_transfer || 0) +
                      Number(dataPengeluaran?.nominal_pendapatan || 0)
                  : // - Number(dataPengeluaran?.nominal_pengeluaran || 0)
                    Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Math.abs(
                        Number(
                          dataDetail?.total_selisih_murni_akumulasi_kondisi ||
                            0,
                        ),
                      ),
              )}
            />
            {hasData && (
              <Box
                sx={{
                  paddingY: 0.5,
                  paddingX: 2,
                  borderBottom: "0.5px solid #ccc",
                  backgroundColor: "#e8f5e9",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "600",
                      color: "success.main",
                    }}
                  >
                    Pendapatan Transfer (+)
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "success.main", fontWeight: "500" }}
                  >
                    {formatRupiah(dataPengeluaran?.transfer_pendapatan || 0)}
                  </Typography>
                </Box>
              </Box>
            )}

            <RowItem
              label="Uang Transfer"
              value={formatRupiah(dataDetail?.total_transfer)}
              isBold
            />
            <RowItem
              label="Total Uang Transfer"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataPengeluaran?.transfer_pendapatan || 0) +
                      Number(dataDetail?.total_transfer || 0)
                  : Number(dataDetail?.total_transfer || 0),
              )}
            />
            <RowItem
              label="Subtotal Omzet"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Number(dataPengeluaran?.nominal_pendapatan || 0) +
                      // - Number(dataPengeluaran?.nominal_pengeluaran || 0)
                      Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Math.abs(
                        Number(
                          dataDetail?.total_selisih_murni_akumulasi_kondisi ||
                            0,
                        ),
                      ),
              )}
            />

            <RowItem
              label="STL"
              value={formatRupiah(dataDetail?.total_stl_akumulasi)}
            />
            <RowItem
              label="EDC Machine"
              value={formatRupiah(dataDetail?.total_debit_credit_akumulasi)}
            />
            <RowItem
              label="Qris"
              value={formatRupiah(dataDetail?.total_ewallet_akumulasi)}
            />

            <RowItem
              label="Total Omzet"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Number(dataPengeluaran?.nominal_pendapatan || 0) +
                      // - Number(dataPengeluaran?.nominal_pengeluaran || 0)
                      Number(dataDetail?.total_stl_akumulasi || 0) +
                      Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                      Number(dataDetail?.total_ewallet_akumulasi || 0) +
                      // Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
                      Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Number(dataDetail?.total_stl_akumulasi || 0) +
                      Math.abs(
                        Number(
                          dataDetail?.total_selisih_murni_akumulasi_kondisi ||
                            0,
                        ),
                      ) +
                      Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                      Number(dataDetail?.total_ewallet_akumulasi || 0),
                // + Number(dataDetail?.total_pengeluaran_akumulasi || 0),
              )}
            />

            <RowItem
              label="Pengeluaran"
              value={formatRupiah(dataDetail?.total_pengeluaran_akumulasi)}
            />

            <RowItem
              label="Total Omzet Data Server"
              isBold
              value={formatRupiah(
                Number(dataDetail?.total_omzet_data_akumulasi || 0),
              )}
            />

            <RowItem
              label="Total Selisih Omzet"
              isBold
              value={formatRupiah(
                (hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataPengeluaran?.nominal_pendapatan || 0) +
                    // - Number(dataPengeluaran?.nominal_pengeluaran || 0)
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0) +
                    // Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
                    Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Math.abs(
                      Number(
                        dataDetail?.total_selisih_murni_akumulasi_kondisi || 0,
                      ),
                    ) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0)) -
                  // +
                  // Number(dataDetail?.total_pengeluaran_akumulasi || 0)
                  Number(dataDetail?.total_omzet_data_akumulasi || 0),
              )}
              isRed={
                (hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataPengeluaran?.nominal_pendapatan || 0) +
                    // -
                    // Number(dataPengeluaran?.nominal_pengeluaran || 0)
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0) +
                    // Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
                    Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Math.abs(
                      Number(
                        dataDetail?.total_selisih_murni_akumulasi_kondisi || 0,
                      ),
                    ) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0) +
                    // Number(dataDetail?.total_pengeluaran_akumulasi || 0)
                    Number(dataPengeluaran?.transfer_pendapatan || 0)) -
                  Number(dataDetail?.total_omzet_data_akumulasi || 0) <
                0
              }
            />

            {dataDetail?.catatan_akumulasi &&
              dataDetail.catatan_akumulasi
                .split(" ; ")
                .filter((item) => item.trim())
                .map((item, i) => (
                  <Typography
                    key={i}
                    variant="body2"
                    sx={{ mt: 1, px: 2, color: "text.secondary" }}
                  >
                    <b>Note {i + 1}:</b> {item.trim()}
                  </Typography>
                ))}
            <Divider />
          </Box>

          {/* BAGIAN KANAN */}
          <Box sx={{ flex: 1, px: 2, py: 1 }}>
            <RowItem label="Rincian" isBold />
            {[
              {
                label: "100rb",
                nominal: 100000,
                total: dataDetail?.total_lembar_seratus,
                masuk: dataPengeluaran?.seratus_pendapatan,
                keluar: dataPengeluaran?.seratus_pengeluaran,
              },
              {
                label: "50rb",
                nominal: 50000,
                total: dataDetail?.total_lembar_limapuluh,
                masuk: dataPengeluaran?.limapuluh_pendapatan,
                keluar: dataPengeluaran?.limapuluh_pengeluaran,
              },
              {
                label: "20rb",
                nominal: 20000,
                total: dataDetail?.total_lembar_duapuluh,
                masuk: dataPengeluaran?.duapuluh_pendapatan,
                keluar: dataPengeluaran?.duapuluh_pengeluaran,
              },
              {
                label: "10rb",
                nominal: 10000,
                total: dataDetail?.total_lembar_sepuluh,
                masuk: dataPengeluaran?.sepuluh_pendapatan,
                keluar: dataPengeluaran?.sepuluh_pengeluaran,
              },
              {
                label: "5rb",
                nominal: 5000,
                total: dataDetail?.total_lembar_limaribu,
                masuk: dataPengeluaran?.limaribu_pendapatan,
                keluar: dataPengeluaran?.limaribu_pengeluaran,
              },
              {
                label: "2rb",
                nominal: 2000,
                total: dataDetail?.total_lembar_duaribu,
                masuk: dataPengeluaran?.duaribu_pendapatan,
                keluar: dataPengeluaran?.duaribu_pengeluaran,
              },
              {
                label: "1rb",
                nominal: 1000,
                total: dataDetail?.total_lembar_seribu,
                masuk: dataPengeluaran?.seribu_pendapatan,
                keluar: dataPengeluaran?.seribu_pengeluaran,
              },
            ].map((p, i) => (
              <RowItem
                key={i}
                label={`Pecahan ${p.label}`}
                value={hitungPecahan(
                  hasData,
                  p.total,
                  p.masuk,
                  p.keluar,
                  p.nominal,
                )}
              />
            ))}

            <RowItem
              label="Pecahan Coin"
              value={
                !hasData
                  ? formatRupiah(dataDetail?.total_coin ?? 0)
                  : `(${formatRupiah(
                      dataDetail?.total_coin ?? 0,
                    )} + ${formatRupiah(
                      dataPengeluaran?.coin_pendapatan ?? 0,
                    )} - ${formatRupiah(
                      dataPengeluaran?.coin_pengeluaran ?? 0,
                    )}) = ${formatRupiah(
                      (Number(dataDetail?.total_coin) ?? 0) +
                        (Number(dataPengeluaran?.coin_pendapatan) ?? 0) -
                        (Number(dataPengeluaran?.coin_pengeluaran) ?? 0),
                    )}`
              }
            />

            {/* <RowItem
              label="Transfer"
              value={formatRupiah(dataDetail?.total_transfer ?? 0)}
            /> */}
          </Box>
        </Box>

        {/* LIST PENDAPATAN & PENGELUARAN */}
        {hasData && (
          <Box sx={{ px: 2, py: 1, mt: 1 }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              mb={2}
            >
              Rincian Pendapatan & Pengeluaran
            </Typography>
            <Box sx={{ display: "flex", gap: 3 }}>
              {/* Pendapatan */}
              <Box
                sx={{
                  flex: 1,
                  border: "1px solid #eee",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  mb={1}
                  color="success.main"
                >
                  PENDAPATAN
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Pendapatan
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="success.main"
                  mb={1}
                >
                  {formatRupiah(dataPengeluaran.nominal_pendapatan)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  List Pendapatan
                </Typography>
                {dataPengeluaran.list_pendapatan ? (
                  dataPengeluaran.list_pendapatan.split(";").map((item, i) => (
                    <Typography key={i} variant="body2">
                      {i + 1}. {item.trim()}
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body2">-</Typography>
                )}
              </Box>

              {/* Pengeluaran */}
              <Box
                sx={{
                  flex: 1,
                  border: "1px solid #eee",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  mb={1}
                  color="error.main"
                >
                  PENGELUARAN
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Pengeluaran
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="error.main"
                  mb={1}
                >
                  {formatRupiah(dataPengeluaran.nominal_pengeluaran)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  List Pengeluaran
                </Typography>
                {dataPengeluaran.list_pengeluaran ? (
                  dataPengeluaran.list_pengeluaran.split(";").map((item, i) => (
                    <Typography key={i} variant="body2">
                      {i + 1}. {item.trim()}
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body2">-</Typography>
                )}
              </Box>
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          p: 2,
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Button
          onClick={handleSaveWarkat}
          variant="contained"
          sx={{
            fontWeight: "bold",
            flexGrow: 1,
            backgroundColor: (t) => t.palette.secondary[300],
            color: "white",
          }}
        >
          {dataDetail.has_save_warkat
            ? "PERBAHARUI KE DATA WARKAT"
            : "SIMPAN KE DATA WARKAT"}
        </Button>

         <Button
          onClick={handlePrint}
          variant="contained"
          startIcon={<PrintIcon />}
          sx={{
            fontWeight: "bold",
            flexGrow: 1,
            backgroundColor: (t) => t.palette.info.main,
            color: "white",
            "&:hover": { backgroundColor: (t) => t.palette.info.dark },
          }}
        >
          CETAK
        </Button>

        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            fontWeight: "bold",
            flexGrow: 1,
            backgroundColor: (t) => t.palette.grey[300],
            color: (t) => t.palette.text.primary,
            "&:hover": { backgroundColor: (t) => t.palette.grey[400] },
          }}
        >
          TUTUP
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetailSetoranHarianModal;
